import { gallerySectionOne } from "data/gallerySection";
import useActive from "hooks/useActive";
import Link from "next/link";
import React, { useState } from "react";
// import Masonry from "react-masonry-component";
import GalleryItem from "./GalleryItem";
import { Box, ImageList } from "@mui/material";
import MansonryLoader from "components/MansonryLoader/MansonryLoader";
import { useAppStore } from "lib/store";

const masonryOptions = {
  transitionDuration: 500,
};

const { title, tabBtns, items } = gallerySectionOne;

const getCurrentItems = (current = "") =>
  items.filter((it) => it.filter.includes(current));

const getCount = (current = "") => getCurrentItems(current).length;

const GallerySectionOne = ({ portfolio = false, similar = false }) => {
  const [current, setCurrent] = useState("all");
  const currentItems = getCurrentItems(current);
  const ref = useActive("#portfolio");
  const { loading, error, engineeringSolutions } = useAppStore();

  return (
    <section
      ref={ref}
      className={`gallery-section${similar ? " similar-gallery" : ""}`}
      id="portfolio"
    >
      <div className="auto-container">
        <div className="sec-title centered">
          <h2>
            PLANT MAINTENANCE
            <span className="dot">.</span>
          </h2>
        </div>
        <div className="mixitup-gallery">
        <Box sx={{ width: '100%', height: 450, overflowY: 'scroll' }}>
            <ImageList variant="masonry" cols={3} gap={8}>
              {Array(engineeringSolutions.total).fill(0).slice(0, Array(engineeringSolutions.total).length).map((item, index) => (
                index != 0 && <MansonryLoader
                  key={`${engineeringSolutions.title}-${index}`}
                  title={engineeringSolutions.title}
                  count={index}
                  path={engineeringSolutions.path}
                  alt='Engineering-Solutions' />
              ))}
            </ImageList>
          </Box>
        </div>
      </div>
    </section>
  );
};

export default GallerySectionOne;
